import React from 'react';

import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {AthleteNextGameModuleProps} from "../models/athlete-next-game.module.props";
import {AthleteNextGameModuleController} from "../athlete-next-game.module.controller";
import classNames from "classnames";
import styles from "../styles/athlete-next-game.module.scss";
import {GameCard} from "../../../../../core/components/game-card/components/game-card";
import {WidgetWrapper} from "../../../../../core/components/misc/widget-wrapper/widget-wrapper";
import {AthleteNextGamePredictionsModule} from "./athlete-next-game.predictions.module";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../../../core/consts";
import {APP} from "../../../../../core/app/consts";
import {Loader} from "../../../../../core/components/loading/loader";
import {PREDICTION_WIDGET} from "../../../../prediction-widget/predictions-widget.consts";

export const AthleteNextGameModule = (({controller}: AthleteNextGameModuleProps) => {
  const {state, device, terms, config} = controller;
  const {isSmallView} = device;
  const {source} = config;
  const {
    nextGame,
    cardTitle,
    gameId,
    statusGroup,
    currentLinkModel,
    competitionId,
    isInnerLinksBlocked,
    componentState,
    selectedBookmaker
  } = state;

  const wrapperProps = {
    controller,
    className: classNames(styles.container, {[styles.small_view]: isSmallView}),
    title: cardTitle,
    sportTypeId: nextGame?.sportId,
    source
  }

  const betsImpressionParams = {
    bookieId: selectedBookmaker?.id,
    bookieName: selectedBookmaker?.name,
    sportTypeId: nextGame?.sportId,
    subSource: PREDICTION_WIDGET.TABS_LABEL.props
  }

  const onMatchClickEvent = () => {
    controller.action(ACTION_TYPES.matchDetailsClick, {
      gameId,
      competitionId,
      status: statusGroup,
      source: APP.ANALYTICS.SOURCES.athleteNextGame,
      placement: APP.GOOGLE_ANALYTICS.SOURCES[currentLinkModel.name],
      currentLinkModelName: currentLinkModel.name,
      sportTypeId: nextGame?.sportId,
    });

    return true;
  }

  const gameProps = {
    terms,
    device,
    controller,
    game: nextGame,
    isSmallView,
    disableSelection: true,
    isFullGameCard: nextGame?.athleteNotInSquad,
    onClick: !isInnerLinksBlocked ? onMatchClickEvent : null,
  }

  const predictionsProps = {
    controller,
    betsImpressionParams
  }

  const loaderProps = {
    className: classNames(styles.loader),
    when: componentState === COMPONENT_STATES.loading
  }

  return (
    <Loader {...loaderProps}>
      <WidgetWrapper {...wrapperProps}>
        <GameCard {...gameProps}/>
        <AthleteNextGamePredictionsModule {...predictionsProps}/>
      </WidgetWrapper>
    </Loader>
  )
});

const settings: ComposeSettings = {
  component: AthleteNextGameModule,
  propsType: AthleteNextGameModuleProps,
  controllerType: AthleteNextGameModuleController,

  observe: true,
  createModule: true
};

export default Compose(settings);
